import NotFoundIcon from '@/common/assets/icons/not-found-expert-icon.svg?react';
import ToolsIcon from '@/common/assets/icons/tools.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import LoadingPage from '@/common/pages/LoadingPage';
import SubstitutionPartsCard from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/SubstitutionPartsCard/SubstitutionPartsCard';
import { ISubstitutionPartsOptions } from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/SubstitutionPartsCard/SubstitutionPartsCard.type';
import RemoveSubstitutionPartModal from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/RemoveSubstitutionPartModal';
import { getInitialVisitAccessoryListQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitAccessoryList/getInitialVisitAccessoryListQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useId, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import { INITIAL_VISIT_ACCESSORY_FORM } from '../../pages/damaged/initialVisit/initialVisitLink';

const AccessoryList = ({ isEditable = true }: { isEditable?: boolean }) => {
  const [removeModal, setRemoveModal] = useState(false);
  const [partId, setPartId] = useState<number>(0);
  const [partName, setPartName] = useState<string>('');
  const { id: paramId } = useParams();
  const id = useId();
  const navigate = useNavigate();

  const {
    data,
    isPending: loading,
    refetch: getSubstitutionPartsList,
  } = useQuery(
    getInitialVisitAccessoryListQueryOptions({
      id: Number(paramId) || 0,
    }),
  );

  const removeModalHandler = (id: number) => {
    setPartId(id);
    const name =
      data?.substitution?.parts?.find((item) => item.id === id)?.name || '';
    setPartName(name);
    setRemoveModal(true);
  };

  return (
    <Box
      px={16}
      py={8}
      border="1px dashed"
      borderColor="gray-1"
      borderRadius={8}
      mt={8}
    >
      <RemoveSubstitutionPartModal
        partName={partName}
        removeModal={removeModal}
        setRemoveModal={setRemoveModal}
        partId={partId}
        completeRemove={() => {
          getSubstitutionPartsList();
        }}
        type="initial"
      />
      <Box display="flex" alignItems="center" gap={8}>
        <Typography textStyle="b1" color="purple-1">
          لیست لوازم اضافی
        </Typography>
        {!!data?.count && data.count > 0 && (
          <Box
            bg="purple-6"
            w={47}
            h={24}
            color="purple"
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius={8}
          >
            <Typography textStyle="b4" color="purple-1">
              {`${data.count} مورد`}
            </Typography>
          </Box>
        )}
      </Box>
      {!!data?.total_price && (
        <Box
          w="100%"
          bg="green-4"
          px={8}
          py={5}
          borderRadius={4}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mt={16}
        >
          <Typography textStyle="b4" color="green-1">
            مجموع هزینه :
          </Typography>
          <Typography textStyle="b4" color="green-1">
            {`${data?.total_price.toLocaleString('fa')} ریال`}
          </Typography>
        </Box>
      )}
      {data?.count && data.count > 0 ? (
        <Box mt={16}>
          {loading ? (
            <LoadingPage />
          ) : (
            <Box>
              {data?.cartData?.map((item, index) => (
                <SubstitutionPartsCard
                  index={index}
                  key={`${id + Math.random()}-id`}
                  data={item as ISubstitutionPartsOptions[]}
                  editAble={isEditable}
                  id={data?.id[index].id}
                  edit={() =>
                    navigate(INITIAL_VISIT_ACCESSORY_FORM, {
                      state: data?.id[index].id,
                    })
                  }
                  remove={(id) => removeModalHandler(id)}
                  icon={<ToolsIcon />}
                />
              ))}
            </Box>
          )}
        </Box>
      ) : (
        <Box
          w="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          gap={16}
          mt={22}
        >
          <NotFoundIcon />
          <Typography textStyle="b3" color="black-3">
            لوازم اضافی ثبت نشده است.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export default AccessoryList;
